import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { portalReportsApi, type ReportDetail } from "../api/portalReportsApi";
import { PageHeader } from "../components/layout/PageHeader";
import { ErrorTile } from "../components/reports/ReportBits";
import { DynamicReport } from "../components/reports/dynamic/DynamicReport";

/** A dynamic (admin-built) report for the signed-in session: /reports/custom/:reportName. */
export function CustomReportPage() {
  const { reportName: param } = useParams<{ reportName: string }>();
  const reportName = param ?? "";
  const [detail, setDetail] = useState<ReportDetail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setDetail(null);
    setError(null);
    portalReportsApi
      .get(reportName)
      .then((d) => active && setDetail(d))
      .catch((err) => active && setError(err instanceof Error ? err.message : "Failed to load the report"));
    return () => {
      active = false;
    };
  }, [reportName]);

  return (
    <>
      <PageHeader title={detail?.menuLabel ?? "Report"} />
      <div className="dashboard">
        {error && <ErrorTile message={error === "Not Found" ? "This report is not available." : error} />}
        {!detail && !error && <div className="tile" style={{ color: "var(--portal-muted)" }}>Loading…</div>}
        {detail && (
          <>
            {detail.description && <p style={{ margin: "0 0 12px", color: "var(--portal-muted)" }}>{detail.description}</p>}
            <DynamicReport
              key={detail.name}
              definition={detail.definition}
              run={async (inputs) => (await portalReportsApi.run(detail.name, inputs)).sections}
              loadOptions={(key) => portalReportsApi.inputOptions(detail.name, key)}
              exportName={detail.menuLabel}
            />
          </>
        )}
      </div>
    </>
  );
}
